
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Évry-Courcouronnes dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Évry-Courcouronnes certifiée Google Partner, accompagne les entreprises évryennes-courcouronnaises pour accroître leur visibilité et générer davantage de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Évry-Courcouronnes dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Évry-Courcouronnes certifiée Google Partner, accompagne les entreprises évryennes-courcouronnaises pour accroître leur visibilité et générer davantage de prospects.",
        },
      ],
    };
  },
};
